import {
  FETCH_OFFERING_PATTERNS,
  FETCH_OFFERING_PATTERNS_ERROR,
  FETCH_OFFERING_PATTERNS_SUCCESS,
  FETCH_SEASON_GAPS_ERROR,
  FETCH_SEASON_GAPS_SUCCESS,
  SAVE_OFFERING_PATTERN,
  SAVE_OFFERING_PATTERN_ERROR,
  SAVE_OFFERING_PATTERN_SUCCESS,
} from './types';

const initialState = {
  patterns: [],
  loading: false,
  error: false,
  saving: false,
  seasonGaps: [],
};

const replaceRow = (patterns, saved) =>
  saved && typeof saved === 'object' ? patterns.map((p) => (p.srMasterId === saved.srMasterId ? saved : p)) : patterns;

const degreePlanningOfferingPatternsReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_OFFERING_PATTERNS:
      return { ...state, loading: true, error: false };
    case FETCH_OFFERING_PATTERNS_SUCCESS:
      return { ...state, loading: false, patterns: action.payload };
    case FETCH_OFFERING_PATTERNS_ERROR:
      return { ...state, loading: false, error: true };
    case SAVE_OFFERING_PATTERN:
      return { ...state, saving: true };
    case SAVE_OFFERING_PATTERN_SUCCESS:
      return { ...state, saving: false, patterns: replaceRow(state.patterns, action.payload) };
    case SAVE_OFFERING_PATTERN_ERROR:
      return { ...state, saving: false };
    case FETCH_SEASON_GAPS_SUCCESS:
      return { ...state, seasonGaps: Array.isArray(action.payload) ? action.payload : [] };
    case FETCH_SEASON_GAPS_ERROR:
      return { ...state, seasonGaps: [] };
    default:
      return state;
  }
};

export default degreePlanningOfferingPatternsReducer;
